import { createOrgCompliance } from './states';

export const services = {
  createOrgCompliance,
};
